<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="col-md-5">
      <h3 class="ls-title-4">{{ $t('settings.attributes.payment_methods') }}</h3>
      <p>{{ $t('settings.label.configure_new') }}</p>
    </div>
    <div class="col-md-7">
      <div class="col-md-12">
        <div class="ls-float-right ls-md-margin-bottom">
          <router-link :to="'/settings/payment_settings/' + processor + '/new'" class="ls-btn-primary">{{ $t('settings.label.buttons.add_payment_method') }}</router-link>
        </div>
      </div>
      <div class="ls-float-right col-md-12" v-for="type in types">
        <payment-list :type="type" v-if="type"></payment-list>
      </div>
    </div>
    <div class="ls-clearfix"></div>
    <div class="ls-actions-btn col-md-12">
      <router-link :to='"/settings/payment_settings/index"' class="ls-btn ls-float-right" :title="$t('application.menu.payment_settings')">{{ $t('application.button.back') }}</router-link>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import PaymentList from './components/PaymentList'
  import * as test from 'src/utils/gateway_payment_method'

  export default {
    name: 'show',
    components: {
      Regroup,
      Breadcrumb,
      Dropdown,
      PaymentList
    },
    data () {
      return {
        types: [],
        processor: '',
        selected: [],
        selectedType: '',
        active: { show: false },
        inactive: { show: false },
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.payment_methods'),
          'paths': {
            0: {
              'title': this.$t('settings.main.select_payment_method'),
              'path': '/settings/payment_settings'
            },
            1: {
              'title': this.$t('settings.main.payment_acquirer'),
              'path': '/settings/payment_settings/index'
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters(['paymentMethods']),
      selectAll: {
        get: function () {
          return this.paymentMethods ? this.selected.length === this.paymentMethods.length : false
        },
        set: function (value) {
          this.selected = []
          if (value) {
            for (var i = 0; i < this.paymentMethods.length; i++) {
              this.selected.push(this.paymentMethods[i].name)
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['loadPaymentMethods', 'loadProcessors', 'clearPaymentMethods']),
      ...mapMutations(['clearPaymentMethods', 'addFlash']),
      status (status) {
        return status ? 'ls-tag-success' : 'ls-tag-default'
      },
      parseType (type) {
        switch (type) {
          case 'Credito': return 'c'
          case 'Boleto': return 'b'
        }
      },
      showModal (modal, index) {
        modal.payment = { processor: this.processor, method: this.paymentMethods[index].name }
        modal.show = true
      }
    },
    mounted () {
      this.$loader.show()
      this.clearPaymentMethods()
      this.processor = this.$route.params.processor
      this.types = test.billetOrCard(this.processor)
      if (this.types !== '') {
        this.$loader.hide()
      }
      if (this.types == null) {
        this.addFlash({ message: this.$t('settings.alerts.processor_not_found'), type: 'ls-alert-danger' })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ShowPaymentSettings.vue?08203cd4